// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#ascendon {
  margin: 0;
}

#ascendon {
  display: flex;
  justify-content: center;
}

#ascendon-iframe {
  width: 100%;
  min-width: 320px;
  background-color: #f7fafc;
}

#ascendon-controls {
  display: none;
}

/* Custom Loader Start */
#ascendon-loader {
  background-color: #ffffff;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  opacity: 0.9;
}

#ascendon-loading {
  border-radius: 100%;
  height: 100px;
  width: 100px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -100px;
  margin-left: -50px;
  width: 48px;
  height: 48px;
  border: 5px solid #000000;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* Custom Loader End */`, "",{"version":3,"sources":["webpack://./ascendonController/src/styles/ascendonController.scss"],"names":[],"mappings":"AAEA;;;EAGE,SAAA;AADF;;AAMA;EACE,aAAA;EACA,uBAAA;AAHF;;AAMA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;AAHF;;AAQA;EACE,aAAA;AALF;;AAQA,wBAAA;AACA;EACE,yBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;AALF;;AAOA;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sCAAA;AAJF;;AAOA;EACE;IACE,uBAAA;EAJF;EAMA;IACE,yBAAA;EAJF;AACF;AAOA,sBAAA","sourcesContent":["$headerHeight: 64px;\n\nhtml,\nbody,\n#ascendon {\n  margin: 0;\n  // min-height: calc(100vh - $headerHeight);\n  // min-height: 100vh;\n}\n\n#ascendon {\n  display: flex;\n  justify-content: center;\n}\n\n#ascendon-iframe {\n  width: 100%;\n  min-width: 320px;\n  background-color: #f7fafc;\n  // min-height: calc(100vh - $headerHeight);\n  // min-height: 100vh;\n}\n\n#ascendon-controls {\n  display: none;\n}\n\n/* Custom Loader Start */\n#ascendon-loader {\n  background-color: #ffffff;\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  opacity: 0.9;\n}\n#ascendon-loading {\n  border-radius: 100%;\n  height: 100px;\n  width: 100px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -100px;\n  margin-left: -50px;\n  width: 48px;\n  height: 48px;\n  border: 5px solid #000000;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n}\n\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Custom Loader End */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
